export enum FeatureWebP {
  Lossy = 'lossy',
  LossLess = 'lossless',
  Alpha = 'alpha',
  Animation = 'animation',
}
